export const permissionStatus = {
	LOADING: 'LOADING',
	ALLOWED: 'ALLOWED',
	DISALLOWED: 'DISALLOWED',
} as const;
